import React, { useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  withGoogleMap
} from "react-google-maps";
import { useNavigate } from "react-router";
import markerIcon from "../../../images/marker.png";
import { Event } from "../../../utils/entities/Event";

const NormalMap = 
  withGoogleMap((props: any) => {
    const events = props.events;
    const navigate = useNavigate();
    const goToOportunity = () => {
      navigate(`/evento/${eventSelected.id}`);
    };
    const [eventSelected, setEventSelected] = useState<Event>(
      {} as Event
    );

    const handleClick = (currentEvent: any) => {
      setEventSelected(currentEvent);
    };

    return (
      <GoogleMap
        defaultOptions={{
          center:{
            lat: -34.8833,
            lng: -56.1667,
          },
          gestureHandling: "greedy",
          disableDefaultUI: true,
          zoom: 12,
          minZoom: 8,
          maxZoom: 15,
          streetViewControl: false,
          rotateControl: false,
          panControl: false,
          mapTypeControl: false,
        }}
      >
        {events?.map((events: Event, i: number) => {
          return (
            <Marker
              icon={markerIcon}
              title={events.titulo}
              position={{
                lat: events.coords.x,
                lng: events.coords.y,
              }}
              onClick={() => {
                //setIsOpened(false)
                handleClick(events);
              }}
              key={i}
              
            >
              {eventSelected == events && (
                //<Bubble marker={markerSelected} handleClickFn= {handleClick} />
                <InfoWindow
                  onCloseClick={() => {
                    handleClick(null);
                  }}
                >
                  <div className="dialog-content">
                    <div className="titulo">{eventSelected.ongName}</div>
                    <div className="descripcion">{eventSelected.description}</div>
                    <div className="button-row">
                      <button
                        onClick={() => {goToOportunity()}}
                        type="button"
                        className="ant-btn ant-btn-primary ir-a-donacion"
                      >
                        <span>Ver más</span>
                      </button>
                    </div>
                  </div>                  
                </InfoWindow>
              )}
            </Marker>
          );
        })}
      </GoogleMap>
    );
  })


export default NormalMap;
